import styled from 'styled-components';

export const StyledLoadingMask = styled.div`
    width: 100vw;
    height: 100vh;
    position: fixed;
    left:0;
    top:0;
    z-index: 999999999999;
`;